import store from './store.js'

export default store



// WEBPACK FOOTER //
// ./src/utils/store/index.js